import { useId } from 'react'
import { Switch } from '@components/ui/switch'

type TrayToggleRowProps = {
  label: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

/** Switch + label row for a tray display option (e.g. "Show filename"). */
export function TrayToggleRow({ label, checked, onCheckedChange }: TrayToggleRowProps) {
  const id = useId()

  return (
    <div className="flex w-full min-w-0 items-start gap-3">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
      <label htmlFor={id} className="pt-0.5 text-sm font-medium leading-none text-foreground">
        {label}
      </label>
    </div>
  )
}
